import { BlogMetadata, IArticle } from '@models/article.interface';
import { IAuthorBase } from '@models/author.interface';
import { convert } from 'html-to-text';
import parse from 'html-react-parser';

export const noIndexArticlesSlugs: string[] = [
  'agilie-at-cmocs-2016',
  'agilies-ceo-sergey-gladun-is-among-the-three-finalists-for-the-ceo-of-the-year-at-it-biz-awards-2016',
  'agilies-football-team-becomes-the-absolute-champions-of-the-dnipro-football-it-league-autumn-season-2016',
  'agilie-design-the-year-2016-in-animations',
];

export function articleAuthor(article: IArticle): Required<IAuthorBase> {
  // TODO: Add Memoization here
  const DEFAULT_NAME = 'John Doe';
  const DEFAULT_AVATAR = '/assets/defaults/author.png';

  const author = article.authors?.[0]?.author;
  return {
    name: author?.name || DEFAULT_NAME,
    avatarUrl: author?.avatarUrl || DEFAULT_AVATAR,
    slug: author?.slug || '',
    position: author?.position,
  };
}

const IMG_RGX = /<img.+?src=['"](.+?)['"].+?\/>/g;

export function imageSrcReplacer(content: string): string {
  const subs = content.match(IMG_RGX);
  if (!subs) {
    return content;
  }
  for (const img of subs) {
    const src = img.match(/src=['"](.+?)['"]/);
    if (!src || !src[1]) {
      continue;
    }
    const imageProxyUrl = `/api/imageproxy?url=${encodeURIComponent(src[1])}`;
    const newImage = img.replace(src[0], `src="${imageProxyUrl}"`);
    if (src) {
      content = content.replace(img, newImage);
    }
  }
  return content;
}

// Example
// <img alt="How to Create a Language Learning App Like Duolingo?"
// src="/_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=3840&amp;q=75" decoding="async" data-nimg="fill"
// style="position:absolute;top:0;left:0;bottom:0;right:0;box-sizing:border-box;padding:0;border:none;margin:auto;display:block;width:0;height:0;min-width:100%;max-width:100%;min-height:100%;max-height:100%" sizes="400px"
// srcset="/_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=16&amp;q=75 16w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=32&amp;q=75 32w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=48&amp;q=75 48w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=64&amp;q=75 64w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=96&amp;q=75 96w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=128&amp;q=75 128w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=256&amp;q=75 256w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=384&amp;q=75 384w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=640&amp;q=75 640w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=750&amp;q=75 750w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=828&amp;q=75 828w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=1080&amp;q=75 1080w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=1200&amp;q=75 1200w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=1920&amp;q=75 1920w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=2048&amp;q=75 2048w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=3840&amp;q=75 3840w">

export function getParsedTextFromHTML(html: string): string {
  const removeBreaklinesRegexp = new RegExp(/\s+/g);
  const parsed = convert(html);
  return parsed.replace(removeBreaklinesRegexp, ' ');
}

export function getImagesSourceFromHTML(html: string): string[] {
  const regex: RegExp = new RegExp('<img.*?src=[\'"](.*?)[\'"]', 'gi');
  const matches: RegExpMatchArray[] = Array.from(html.matchAll(regex));
  return matches.map(([image, src]) => src) || [];
}

export function isInternalArticleLink(href: string): boolean {
  try {
    return (
      href.startsWith('/') ||
      href.includes('gofinans.com') ||
      new URL(href).hostname.includes('gofinans')
    );
  } catch {
    // blog/some-article -> ['blog', 'some-article']
    const [hostOrInternalModule] = href.split('/');
    // if it does not include '.', then link is internal
    // i.e. netflix.com (without protocol) return false
    return !hostOrInternalModule.includes('.');
  }
}

export function getNoIndexMetaTag(slug: string): string | JSX.Element | JSX.Element[] {
  if (noIndexArticlesSlugs.includes(slug)) {
    return parse(`<meta name="robots" content="noindex" />`);
  }
  return '';
}

export const toPaginatedMetaText = (page: number, isTitle: boolean = true, t?: (key: string, params?: Record<string, any>) => string): string => {
  const isFirstPage: boolean = page === 1;
  if (isFirstPage || !t) {
    return '';
  }
  if (isTitle) {
    return t('Blog.Pagination_text_line', { page });
  }
  // meta description
  return t('Blog.Pagination_text', { page });
};

export const BLOG_TOPIC_METADATA = (t: (key: string, params?: Record<string, any>) => string): Record<string, BlogMetadata> => ({
  default: {
    h1: 'Blog.Meta.H1',
    title: (page: number) => t('Blog.Meta.Title'),
    description: (page: number) => t('Blog.Meta.Description'),
  },
  compliance: {
    h1: 'Blog.Compliance.Meta.H1',
    title: (page: number) => t('Blog.Compliance.Meta.Title', { pageNumberText: toPaginatedMetaText(page, true, t) }),
    description: (page: number) => t('Blog.Compliance.Meta.Description', { pageNumberText: toPaginatedMetaText(page, false, t) }),
  },
  web3: {
    h1: 'Blog.Web3.Meta.H1',
    title: (page: number) => t('Blog.Web3.Meta.Title', { pageNumberText: toPaginatedMetaText(page, true, t) }),
    description: (page: number) => t('Blog.Web3.Meta.Description', { pageNumberText: toPaginatedMetaText(page, false, t) }),
  },
  security: {
    h1: 'Blog.Security.Meta.H1',
    title: (page: number) => t('Blog.Security.Meta.Title', { pageNumberText: toPaginatedMetaText(page, true, t) }),
    description: (page: number) => t('Blog.Security.Meta.Description', { pageNumberText: toPaginatedMetaText(page, false, t) }),
  },
  insights: {
    h1: 'Blog.Insights.Meta.H1',
    title: (page: number) => t('Blog.Insights.Meta.Title', { pageNumberText: toPaginatedMetaText(page, true, t) }),
    description: (page: number) => t('Blog.Insights.Meta.Description', { pageNumberText: toPaginatedMetaText(page, false, t) }),
  },
  payments: {
    h1: 'Blog.Payments.Meta.H1',
    title: (page: number) => t('Blog.Payments.Meta.Title', { pageNumberText: toPaginatedMetaText(page, true, t) }),
    description: (page: number) => t('Blog.Payments.Meta.Description', { pageNumberText: toPaginatedMetaText(page, false, t) }),
  },
});
